/**
 * Quién responde por una herramienta mientras la asignación espera aceptación
 * (CR-03).
 *
 * La regla del negocio es que la herramienta sigue siendo de quien la tenía
 * hasta que el receptor acepta. El servidor, en cambio, mueve
 * `responsibleUserId` desde que se asigna, así que lo que llega ya trae al
 * nuevo responsable aunque todavía no haya aceptado nada.
 *
 * Mientras el backend no separe las dos cosas, la pantalla no puede decir
 * quién era el anterior —no viene en la respuesta del listado—, pero sí puede
 * dejar de afirmar que la transferencia ya ocurrió. De ahí el aviso.
 */

export type EstadoDeAprobacion = 'pending' | 'approved' | 'rejected' | null

/** La asignación vigente todavía espera que el receptor acepte. */
export const esperaAceptacion = (estado?: EstadoDeAprobacion): boolean =>
  estado === 'pending'

/**
 * Lo que se dice junto al responsable cuando la asignación está en el aire.
 *
 * Nombra a **quien tiene que aceptar**, no al responsable: desde que el back
 * aplica la regla, el responsable que llega es el anterior, y poner su nombre
 * aquí diría justo lo contrario de lo que pasa.
 */
export const avisoDePendiente = (
  pendienteDe: string | null | undefined,
): string =>
  pendienteDe && pendienteDe.trim() !== ''
    ? `Pendiente de aceptar por ${pendienteDe}`
    : 'Pendiente de aceptación'
